module.exports = __webpack_public_path__ + "static/media/subscriptionIcon.633fe327.svg";